import styled from "@emotion/styled";
import { Button } from "nectar-ui";
import { NectarTheme } from "../../../typings/theme";

export const FilterButton = styled(Button)`
  ${({ theme }: NectarTheme) => `
    text-transform: none !important;
    background-color: ${theme.colors.gray100};
    font-weight: 500 !important;
    letter-spacing: 0 !important;
    font-size: 14px !important;
  `}
`;
